import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import { useDispatch, useSelector } from "react-redux";
import { coinsHistory } from "./cl_LoyalltyCoins";
import GameLoss from "../../assets/images/game-loss.svg";
import Burn from "../../assets/images/burn.svg";
import friendSignUp from "../../assets/images/signup.svg";
import friendDeposit from "../../assets/images/friend-deposit.svg";
import { getUserDetails } from "../signIn/cl_SignInSlice";
import moment from "moment";
import PaginationComponent from "../common/PaginationComponent";
import coin from "../../assets/images/coin.svg";
import icons from "../../assets/images/sprite-other-icons.svg";
import jaqkCoin from "../../assets/images/coin.svg";

const CoinsHistory = () => {
  const dispatch = useDispatch();
  const { coinsHistoryData, loader } = useSelector(
    (state) => state.coinsHistory
  );
  const { userLoyalty } = useSelector((state) => state?.signIn);
  const [coinsHistoryTotalData, setCoinsHistoryTotalData] = useState([]);
  const [transactionType, setTransactionType] = useState("ALL");
  const [showAbove, setShowAbove] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  const iconRefs = useRef([]);
  const popupRefs = useRef([]);
  const PageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const filteredData =
    coinsHistoryData &&
    coinsHistoryData?.filter(
      (item) => item?.bonusType === "coins" || item.bonusType === ""
    );

  const paginatedData =
    coinsHistoryData &&
    [...coinsHistoryData]
      ?.sort((a, b) => {
        const dateA = new Date(a.created_date).getTime();
        const dateB = new Date(b.created_date).getTime();
        return dateB - dateA;
      })
      ?.slice((currentPage - 1) * PageSize, currentPage * PageSize);
  useEffect(() => {
    dispatch(getUserDetails());
  }, []);
  const loyaltyTypeImages = {
    signup: friendSignUp,
    betlost: GameLoss,
    burn: Burn,
    deposit: friendDeposit,
    default: friendDeposit,
  };
  const userDetails = useSelector((state) => state?.signIn?.userDetails);

  useEffect(() => {
    if (userDetails?.userId) {
      dispatch(coinsHistory(userDetails?.userId, transactionType));
    }
  }, [transactionType, userDetails?.userId]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        userDetails?.userId &&
        transactionType
      ) {
        setOpenSection(null);
        dispatch(coinsHistory(userDetails.userId, transactionType));
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [userDetails, transactionType, dispatch]);

  const togglePopup = (id) => {
    if (openSection === id) {
      setOpenSection(null);
    } else {
      setOpenSection(id);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      iconRefs.current.forEach((ref, index) => {
        if (
          openSection &&
          popupRefs.current[index] &&
          !popupRefs.current[index].contains(event.target) &&
          !ref.contains(event.target)
        ) {
          setOpenSection(null);
        }
      });
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openSection]);
  return (
    <div>
      <div className="SB-myAccountSection-container SB-coinsHistory">
        <div className="SB-pageHeader">
          <div className="SB-pageBackButton">
            <BackArrow />
          </div>
          <div className="SB-pageHeader-title">FasFas Coins History</div>
        </div>
        <div className="SB-myAccount-sectionBox_content">
          <div className="SB-coinsItem-group">
            <div className="SB-coinsItem">
              <div className="SB-coinsItem-label">Coins Balance:</div>
              <div className="SB-coinsItem-value">
                <img src={jaqkCoin} alt="coin"></img>
                {userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0}
              </div>
            </div>
          </div>
        </div>
        <div className="SB-myAccountSection-filters-container">
          <div className="SB-myAccountSection-tabs SB-tabs">
            <ul className="nav">
              <li
                className={`${transactionType === "ALL" ? "active" : ""}`}
                onClick={() => {
                  setTransactionType("ALL");
                  setCurrentPage(1);
                }}
              >
                <Link
                  className={`SB-tab-item nav-link ${
                    transactionType === "ALL" ? "active" : ""
                  }`}
                  href="#tab1"
                  data-toggle="tab"
                >
                  All
                </Link>
              </li>
              <li
                className={`${transactionType === "credit" ? "active" : ""}`}
                onClick={() => {
                  setTransactionType("credit");
                  setCurrentPage(1);
                  setOpenSection(false);
                }}
              >
                <Link
                  className={`SB-tab-item nav-link ${
                    transactionType === "credit" ? "active" : ""
                  }`}
                  href="#tab2"
                  data-toggle="tab"
                >
                  Earns
                </Link>
              </li>
              <li
                className={`${transactionType === "debit" ? "active" : ""}`}
                onClick={() => {
                  setTransactionType("debit");
                  setCurrentPage(1);
                }}
              >
                <Link
                  className={`SB-tab-item nav-link ${
                    transactionType === "debit" ? "active" : ""
                  }`}
                  href="#tab3"
                  data-toggle="tab"
                >
                  Redeem
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="SB-tab-content">
          <div className="SB-coinsHistoryBox">
            <div className="SB-coinsHistory-earn SB-tab-pane active" id="tab2">
              {loader ? (
                <div className="SB-section-loader">
                  <div className="SB-section-loader-container">
                    <span className="SB-dot"></span>
                    <span className="SB-dot"></span>
                    <span className="SB-dot"></span>
                    <span className="SB-dot"></span>
                  </div>
                </div>
              ) : (
                <>
                  {paginatedData?.length > 0 ? (
                    paginatedData?.map((coinHist, ind) => (
                      <>
                        {coinHist?.loyaltyType === "betPlacement" ? (
                          ""
                        ) : (
                          <div className="SB-coinsHistory-item" key={ind}>
                            <div className="SB-coinsHistory__col SB-col1">
                              <div className="SB-coinsHistory-dateID">
                                <div className="SB-coinsHistory-id">
                                  ID TNX-{coinHist?._id}
                                </div>
                                <div className="SB-coinsTransactionDate">
                                  {moment(coinHist.created_date).format(
                                    "DD/MM/YYYY HH:mm:ss"
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="SB-coinsHistory__col SB-col2">
                              <div className="SB-coinsHistory-content">
                                <div className="SB-coinsHistory-category">
                                  <div className="SB-coinsHistory-icon">
                                    <img
                                      src={
                                        loyaltyTypeImages[
                                          coinHist?.loyaltyType
                                        ] || loyaltyTypeImages.default
                                      }
                                      alt="friend-deposit"
                                    />
                                  </div>
                                  <span style={{ textTransform: "capitalize" }}>
                                    {coinHist?.bonusType === "referal_bonus"
                                      ? "Referral Bonus"
                                      : coinHist?.loyaltyType === "burn"
                                      ? "Redemption"
                                      : coinHist?.loyaltyType}
                                  </span>
                                </div>
                                <div
                                  className={`SB-coinsHistory-discription ${
                                    coinHist?.status
                                      ?.replace(/\s+/g, "")
                                      ?.toLowerCase() === "creditsuccess"
                                      ? "SB-cashCredit"
                                      : ""
                                  }`}
                                >
                                  {coinHist?.status
                                    ?.replace(/\s+/g, "")
                                    ?.toLowerCase() === "creditsuccess" ? (
                                    <>
                                      Cash Credit:{" "}
                                      <span className="SB-cash">
                                        KES{" "}
                                        {typeof coinHist?.amount === "object"
                                          ? coinHist?.amount?.$numberDecimal
                                          : coinHist?.amount?.toFixed(2)}
                                      </span>
                                    </>
                                  ) : coinHist?.loyaltyType === "betlost" ? (
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      Game: {coinHist?.gameName}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="SB-coins-statusAmount">
                                <div
                                  className={`SB-coinsValue ${
                                    coinHist?.IsRewarded ||
                                    coinHist?.loyaltyType === "signup" ||
                                    coinHist?.loyaltyType === "betPlacement" ||
                                    coinHist?.bonusType === "referal_bonus"
                                      ? " SB-success"
                                      : "SB-cumulativeCoins"
                                  }`}
                                >
                                  {(coinHist?.IsRewarded &&
                                    coinHist?.coinsCredit) ||
                                  coinHist?.bonusType === "referal_bonus" ? (
                                    <>
                                      <img src={coin} alt="coin" /> +
                                      {Math.floor(coinHist?.coinsCredit)}
                                    </>
                                  ) : coinHist?.loyaltyType === "betlost" ? (
                                    <span>
                                      {Math.round(
                                        coinHist?.cumulativeAmountExists
                                      )}{" "}
                                      / {coinHist?.coinsConfig}
                                    </span>
                                  ) : coinHist?.loyaltyType === "burn" ? (
                                    ""
                                  ) : (
                                    <>+{coinHist?.coinsCredit.toLocaleString()}</>
                                  )}
                                  <>
                                    {coinHist?.loyaltyType === "betlost" ? (
                                      <span
                                        className="SB-coinstooltip"
                                        id="SB-coinstooltip"
                                        ref={(el) =>
                                          (iconRefs.current[ind] = el)
                                        }
                                        onClick={() =>
                                          togglePopup(coinHist._id, ind)
                                        }
                                      >
                                        <div className="SB-iconSVG">
                                          <svg xmlns="http://www.w3.org/2000/svg">
                                            <use
                                              xlinkHref={`${icons}#${"icon-tooltip"}`}
                                            ></use>
                                          </svg>
                                        </div>
                                        {openSection === coinHist?._id && (
                                          <div
                                            ref={(el) =>
                                              (popupRefs.current[ind] = el)
                                            }
                                            className="SB-cumulative-details"
                                            style={{ display: "block" }}
                                          >
                                            <div className="SB-title">
                                              Cumulative Betloss Details
                                            </div>
                                            <div className="SB-cumulativeBalance">
                                              <div className="SB-cumulativeItem">
                                                <span className="SB-label">
                                                  Total Cumulative
                                                </span>
                                                <span className="SB-value">
                                                  KES{" "}
                                                  {Math.round(
                                                    coinHist?.cumulativeAmountExists
                                                  )}
                                                </span>
                                              </div>
                                              <div className="SB-cumulativeItem SB-awarded">
                                                <span className="SB-label">
                                                  Awarded
                                                </span>
                                                <span className="SB-value">
                                                  <img src={coin} alt="coin" />
                                                  {coinHist?.coinsCredit}
                                                </span>
                                              </div>
                                              <div className="SB-cumulativeItem SB-remaining">
                                                <span className="SB-label">
                                                  Remaining
                                                </span>
                                                <span className="SB-value">
                                                  KES{" "}
                                                  {Math.round(
                                                    coinHist?.amountRemaining
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="SB-coinsHistory-details">
                                              {coinHist?.linkedTransactions
                                                ?.slice()
                                                ?.sort(
                                                  (a, b) =>
                                                    new Date(b.created_date) -
                                                    new Date(a.created_date)
                                                )
                                                ?.map((transactions, index) => {
                                                  return (
                                                    <div className="SB-coinHistory-item">
                                                      {transactions?.carriedAmount >
                                                        0 && (
                                                        <div className="SB-coinscarryForward">
                                                          <div className="SB-coinsHistory-discription">
                                                            Carried Forward
                                                          </div>
                                                          <div className="SB-coinsValue">
                                                            KES{" "}
                                                            {transactions?.carriedAmount.toFixed(
                                                              2
                                                            )}
                                                          </div>
                                                        </div>
                                                      )}

                                                      <div className="SB-coinsHistory-dateID">
                                                        <div className="SB-coinsHistory-id">
                                                          ID:{" "}
                                                          {transactions?.betId}
                                                        </div>
                                                        <div className="SB-coinsTransactionDate">
                                                          {moment(
                                                            transactions.created_date
                                                          ).format(
                                                            "DD/MM/YYYY HH:mm:ss"
                                                          )}
                                                        </div>
                                                      </div>
                                                      <div className="SB-coinsHistory-discriptionValue">
                                                        <div className="SB-coinsHistory-discription">
                                                          <span
                                                            style={{
                                                              textTransform:
                                                                "capitalize",
                                                            }}
                                                          >
                                                            Game:{" "}
                                                            {
                                                              transactions?.gameName
                                                            }
                                                          </span>
                                                        </div>
                                                        <div className="SB-coinsValue">
                                                          KES{" "}
                                                          {Math.round(
                                                            transactions?.amount
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                            <div className="SB-info">
                                              Note: You get{" "}
                                              {
                                                coinHist?.coinsPerConfigStakeLost
                                              }{" "}
                                              coins for every KES{" "}
                                              {coinHist?.coinsConfig} loss
                                            </div>
                                          </div>
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ))
                  ) : (
                    <div className="SB-msgBox">
                      <div className="SB-msgBox-container">
                        Currently there is no data available
                      </div>
                    </div>
                  )}
                  <React.Fragment></React.Fragment>
                  <PaginationComponent
                    onPageChange={(page) => setCurrentPage(page)}
                    totalCount={filteredData?.length || 0}
                    currentPage={currentPage}
                    pageSize={PageSize}
                    setCurrentPage={setCurrentPage}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinsHistory;
